export const inputSemanticTokens = {
  bg: {
    outline: { value: "{colors.primary.white}" },
    outlineFocus: { value: "{colors.primary.white}" },
    search: { value: "{colors.primary.white}" },
  },
  text: {
    outline: { value: "{colors.green.500}" },
    outlinePlaceholder: { value: "{colors.gray.600}" },
    search: { value: "{colors.green.500}" },
    searchPlaceholder: { value: "{colors.gray.800}" },
  },
  border: {
    outline: { value: "{colors.green.200}" },
    outlineFocus: { value: "{colors.green.200}" },
    outlineHover: { value: "{colors.green.200}" },
    search: { value: "{colors.gray.200}" },
    searchBottom: { value: "{colors.gray.200}" },
  },
  fontSizes: {
    sm: { value: "{fontSizes.xs}" },
    md: { value: "{fontSizes.md}" },
    lg: { value: "{fontSizes.lg}" },
  },
  radii: {
    outline: { value: "{radii.xl}" },
    search: { value: "{radii.lg}" },
  },
  fontWeights: {
    normal: { value: "{fontWeights.normal}" },
  },
};
